module.exports = __webpack_public_path__ + "static/media/landing_insights_3.3847c68d.png";